import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Schedule.css'

function Schedule() {
  const [schedulesData, setSchedulesData] = useState(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getSchedules`)
      .then((response) => {
        setSchedulesData(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }, []);

  if (!schedulesData) {
    return <div>加載中 Loading...</div>;
  }
  return (
    <div className="page-content">
      <h2>聚會時間</h2>
      <table className="schedule-table">
        <thead>
          <tr>
            <th>聚會</th>
            <th>時間</th>
            <th>地點</th>
          </tr>
        </thead>
        <tbody>
          {schedulesData.schedules.map((schedule, index) => (
            <tr key={index}>
              <td>{schedule.event}</td>
              <td dangerouslySetInnerHTML={{ __html: schedule.datetime }}></td>
              <td dangerouslySetInnerHTML={{ __html: schedule.venue }}></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Schedule;